
var surveyForm = {


    update: function () {
        var val = $("input[name=Answer1]:checked").val();

        //  return false;
    },
    getParsleyConfig: function () {
        return {
            errorsContainer: function (pEle) {
                var $err = pEle.$element.parents('.covid-survey__element').find('.error');
                return $err;
            },

            uiEnabled: true
        };
    },

    customValidator: function () {

        window.Parsley.addValidator('answer1', {
            requirementType: 'string',
            validateString: function (value, requirements, parsleyInstance) {

                var $row = $(parsleyInstance.$element).parents(".covid-survey__element");

                var answer1 = $row.find("input[name = Answer1]:checked").val();

                if (typeof answer1 === 'Y') {

                    $("#Info1Yes").toggle();
                }
            }
        });
    },

    recaptchaExpired: function () {
        grecaptcha.reset();
        var $submitButton = $(thisForm).find(".js-covid-form__submit");
        $submitButton.prop('disabled', false);
    },

    sumbitForm: function (thisForm) {
        var that = this;
        var form = $(thisForm).parsley(that.getParsleyConfig());
        var response = grecaptcha.getResponse();
        if (response.length == 0) {
            $("#recaptchaError").toggle();
        }
        else {
            $("#recaptchaError").hide();
            var $submitButton = $(thisForm).find(".js-covid-form__submit");
            if (form.validate()) {
                $submitButton.prop('disabled', true);
                $("#survey-success").trigger('focus');
                //  thisForm.find("input[name='cofnirm']").prop("checked");
                var answer1 = $('input[name="Answer1"]:checked').val();
                var answer2 = $('input[name="Answer2"]:checked').val();
                var answer3 = $('input[name="Answer3"]:checked').val();
                var answer4 = $('input[name="Answer4"]:checked').val();
                var answer5 = $('input[name="Answer5"]:checked').val();
                var answer6 = $('input[name="Answer6"]:checked').val();
                var answer7 = $('input[name="Answer7"]:checked').val();
                var answer8 = $('input[name="Answer8"]:checked').val();
                var answer9 = $('input[name="Answer9"]:checked').val();
                var answer10 = $('input[name="Answer10"]:checked').val();
                var answer11 = $('input[name="Answer11"]:checked').val();
                var urlParam = that.getQueryStringByName("aptid");
                var surveyFields = {
                    "clinicalOrderId": urlParam,
                    "Answer1": answer1,
                    "Answer2": answer2,
                    "Answer3": answer3,
                    "Answer4": answer4,
                    "Answer5": answer5,
                    "Answer6": answer6,
                    "Answer7": answer7,
                    "Answer8": answer8,
                    "Answer9": answer9,
                    "Answer10": answer10,
                    "Answer11": answer11
                }

                $.ajax({
                    type: "POST",
                    url: apilocation + "CovidSurveyApi/PostSurveyData",
                    data: JSON.stringify(surveyFields),
                    contentType: "application/json; charset=utf-8",
                    dataType: "json"
                }).done(function (data) {

                    if (data == null) {
                        $("#covidsurvey").hide();
                        $("#heroBlock").hide();
                        $("#SectionText").hide();
                        $("#survey-failure").show();
                    }
                    else if (data.ResultCode == "01") 
                    {
                        $("#covidsurvey").hide();
                        $("#heroBlock").hide();
                        $("#SectionText").hide();
                        $("#survey-failure").show();
                    }
                    else if (data.ResultCode == "03")
                    {
                        that.successData(data);
                    }
                    else if (data.SurveyStatus == "04") {
                        that.successData(data);
                        $("#cancelappointment").show();
                    }
                    else if (data.SurveyStatus == "05") {
                        that.successData(data);
                        $("#contactpatient").show();
                    }
                    else if (data.SurveyStatus == "03") {
                        that.successData(data);
                        $("#surveycompleted").show();
                    }
                    else {
                        that.successData(data);
                    }

                });
            }
        }

    },

    successData: function (data) {
        $("#covidsurvey").hide();
        $("#heroBlock").hide();
        $("#SectionText").hide();
        $("#survey-success").show();
        $("#survey-success").trigger('focus');

        var source = $("#covid-template").html(),
            template,
            context,
            html;
        if (source) {
            template = Handlebars.compile(source);
            context = { ResponseCovid: data };
            html = template(context);
            $("#covid-template").after(html);
        }
    },
    getQueryStringByName: function (name) {

        name = name.replace("/[\[]/", "\\[").replace("/[\]]/", "\\]");
        const regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
            results = regex.exec(location.search);
        return results === null ? "" : decodeURIComponent(decodeURIComponent(results[1].replace(/\+/g, " ")));
    },
    init: function () {
        var that = this;



        var isCovidSurveyForm = $("#covid-survey-form").length > 0;
        if (!isCovidSurveyForm) {
            return;
        }



        $(".js-covid-form__submit").on('click', function (e) {
            e.preventDefault();
            var thisForm = $("#covid-survey-form");
            $(thisForm).parsley();
            //var ans1 = $(thisForm).find("input[name=Answer1]").val();
            //if (typeof ans1 === 'undefined') {
            //    that.update();
            //}
            //else {
            that.sumbitForm(thisForm);
            // }
        });

    }
}

function CovidSurveyModule() {
    $(window).on('load', function () {

        surveyForm.init();

    });

    $("input[name$='Answer1']").on('click', function (e) {
        var val = $(this).val();

        if (val == "Y") {
            $("#Info1Yes").show();
        }
        else {
            $("#Info1Yes").hide();
        }

    });

    $("input[name$='Answer2']").on('click', function (e) {
        var val = $(this).val();

        if (val == "Y") {
            $("#Info2Yes").show();
        }
        else {
            $("#Info2Yes").hide();
        }

    });

    $("input[name$='Answer3']").on('click', function (e) {
        var val = $(this).val();

        if (val == "Y") {
            $("#Info3Yes").show();
        }
        else {
            $("#Info3Yes").hide();
        }

    });

    $("input[name$='Answer4']").on('click', function (e) {
        var val = $(this).val();

        if (val == "Y") {
            $("#Info4Yes").show();
        }
        else {
            $("#Info4Yes").hide();
        }

    });

    $("input[name$='Answer5']").on('click', function (e) {
        var val = $(this).val();

        if (val == "Y") {
            $("#Info5Yes").show();
        }
        else {
            $("#Info5Yes").hide();
        }

    });

    $("input[name$='Answer11']").on('click', function (e) {
        var val = $(this).val();

        if (val == "N") {
            $("#Info11").show();
        }
        else {
            $("#Info11").hide();
        }

    });

    $("input[name$='Answer6']").on('click', function (e) {
        var val = $(this).val();

        if (val == "N") {
            $("#Info6").show();
        }
        else {
            $("#Info6").hide();
        }

    });
    $("input[name$='Answer7']").on('click', function (e) {
        var val = $(this).val();

        if (val == "N") {
            $("#Info7").show();
        }
        else {
            $("#Info7").hide();
        }

    });
    $("input[name$='Answer8']").on('click', function (e) {
        var val = $(this).val();

        if (val == "N") {
            $("#Info8").show();
        }
        else {
            $("#Info8").hide();
        }

    });
    $("input[name$='Answer10']").on('click', function (e) {
        var val = $(this).val();

        if (val == "N") {
            $("#Info10").show();
        }
        else {
            $("#Info10").hide();
        }

    });

    $("input[name$='Answer4']").on('click', function (e) {
        var val = $(this).val();

        if (val == "y") {
            $("#Info4").show();
        }
        else {
            $("#Info4").hide();
        }

    });

    $('[tool-tip-toggle="tooltip-demo"]').tooltip({
        placement: 'top'

    });
}

export { CovidSurveyModule };